import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import Journey from "./sections/Journey";
import Foundation from "./sections/Foundation";
import Heart from "./sections/Heart";
import Environment from "./sections/Environment";
import Testimonials from "./sections/Testimonials";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <Journey />
      <Foundation />
      <Heart />
      <Environment />
      <Testimonials />
      <Faq />
      <Footer />
    </div>;
}